<ng-container *transloco="let t;">
<div class="signing-sidebarInner">
    <span class="signing-sidebar-closeIcon" (click)="toggleSidebar('signing-right-sidebar')">
        <i data-feather="x" [size]="16" data-dismiss="modal" aria-label="Close"></i>
    </span>
    <div class="rightMenuTopContainer">
        <div class="brandLogoContainer">
            @if(roleDetail?.brand?.logo){
                <img [src]="roleDetail?.brand?.logo | signingPageImage:roleDetail?.id | async" class="w-100">
            } @else {
                <img src="../../../../assets/images/logo/blueVariantLogoSimplesignSvg.svg">
            }
        </div>

        <div class="contractNameContainer">
            <h4 class="contractNameFirstText">
                {{ roleDetail?.roleable?.visible_name ?? roleDetail?.roleable.name }}
            </h4>
            <p class="contractNameSecondText">
                <span class="countofpages"></span>
            </p>
        </div>
    </div>

    <div class="sidebar-tab-view-wrapper">      
        <ul ngbNav #navJustified="ngbNav" class="nav-tabs nav-justified">
            <li ngbNavItem>
                <a ngbNavLink>
                    <span [data-feather]="'activity'" [size]="15"></span>
                    {{ t("Sidebar tab title (general) - Activity") }}
                </a>
                <ng-template ngbNavContent>
                    <app-activity-logs [documentDetails$]="roleDetail?.roleable" [roleDetail]="roleDetail" [view]="view" [roleId]="roleId" [document_id]="document_id" [is_sender]="is_sender"></app-activity-logs>
                </ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink>
                    <span [data-feather]="'users'" [size]="15"></span>
                    {{t("Sidebar tab title (general) - Participants")}}
                </a>
                <ng-template ngbNavContent>
                    <app-participants [roleDetail]="roleDetail" [roleId]="roleId" [document_id]="document_id" [is_sender]="is_sender"></app-participants>
                </ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink>
                    <span [data-feather]="'file-text'" [size]="15"></span>
                    {{t("Sidebar tab title (general) - Documents")}}
                </a>
                <ng-template ngbNavContent>
                    <app-documents-tab [roleDetail]="roleDetail" [roleId]="roleId" [document_id]="document_id" [is_sender]="is_sender"></app-documents-tab>
                </ng-template>
            </li>
            <li ngbNavItem *ngIf="!is_sender">
                <a ngbNavLink>
                    <span [data-feather]="'more-horizontal'" [size]="15"></span>
                    {{t("Sidebar tab title (general) - More")}}
                </a>
                <ng-template ngbNavContent>
                    <app-more [roleDetail]="roleDetail" [roleId]="roleId" [document_id]="document_id" [is_sender]="is_sender"></app-more>
                </ng-template>
            </li>
        </ul>
        <div [ngbNavOutlet]="navJustified"></div>      
    </div>
</div>
</ng-container>